module.exports = __webpack_public_path__ + "img/banner03.6cbe3155.png";